export const VISITOR_COUNT = ["500", "1000", "1500", "2000", "3000"]
